import { useContext } from 'react'
import styled from 'styled-components'
import CreationToolSuperCutField from '../../../types/super-cut-field'
import FieldTitle from './field-title'
import { CreationCaptureInfoContext } from '../../supercut/shared/components/capture-info/manager'
import FontPreviewItem from '../../supercut/shared/components/capture-info/font-preview-item'

const Container = styled.div`
    grid-column: span 2;
`

const FontListContainer = styled.div``

type Props = {
    field: CreationToolSuperCutField
}

const CreationCaptureFontPreviewField = ({ field }: Props) => {
    const { font, previousFonts } = useContext(CreationCaptureInfoContext)

    return (
        <>
            {previousFonts.length > 0 ? (
                <Container>
                    <FieldTitle field={field} />
                    <FontListContainer>
                        {previousFonts.map((wm) => {
                            return (
                                <FontPreviewItem
                                    key={wm.id}
                                    font={wm}
                                    currentlySelected={font?.fontUrl === wm.fontUrl}
                                />
                            )
                        })}
                    </FontListContainer>
                </Container>
            ) : null}
        </>
    )
}

export default CreationCaptureFontPreviewField
